// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M5.62136 21.9988H1.99878V18.3762C1.99878 17.5806 2.31485 16.8175 2.87746 16.2549L5.0354 14.097L9.90063 18.9622L7.74269 21.1201C7.18008 21.6828 6.41701 21.9988 5.62136 21.9988Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11.3148 17.548L22.5308 6.33202L17.6656 1.4668L6.44962 12.6828L11.3148 17.548Z"}}]};

const PenBrushFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'pen-brush-filled',
    ref,
    icon: element,
  },
));

PenBrushFilledIcon.displayName = 'PenBrushFilledIcon';

export default PenBrushFilledIcon;
